import React from 'react';
import Skeleton from '@mui/material/Skeleton';

export default function SmCardLoader(props) {
    return (
        <div className="card-skeleton">
            <Skeleton
                animation='wave'
                variant="rectangular"
                {...props.loaderProps}
            />
        </div>
    );
}
